module.exports = __webpack_public_path__ + "static/dashboard-96e9064e851b0448c5e8209299e22a44.jpg";